/** popWindowWheel=3 全屏模板渐变 CSS 变量名（与 C 端 App.css 一致） */
export const FULLSCREEN_GRADIENT_CSS_VARS = {
  pc: '--cartx-fs-gradient-pc',
  endPc: '--cartx-fs-gradient-end-pc',
  mobile: '--cartx-fs-gradient-mobile',
  mobileEnd: '--cartx-fs-gradient-mobile-end'
} as const;

export type FullscreenShowStyleMapKey = 'cartx-b-show' | 'cartx-b-show__middle' | 'cartx-b-show__end';

export function getFullscreenShowStyleMapKey(page: 'start' | 'middle' | 'end'): FullscreenShowStyleMapKey {
  if (page === 'middle') return 'cartx-b-show__middle';
  if (page === 'end') return 'cartx-b-show__end';
  return 'cartx-b-show';
}

type Rgba = { r: number; g: number; b: number; a: number };

export function parseColorToRgba(color?: string): Rgba {
  if (!color || color === 'none' || color === 'transparent') {
    return { r: 0, g: 0, b: 0, a: 1 };
  }
  const c = String(color).trim();
  const rgbaMatch = c.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([\d.]+))?\s*\)/i);
  if (rgbaMatch) {
    return {
      r: Number(rgbaMatch[1]),
      g: Number(rgbaMatch[2]),
      b: Number(rgbaMatch[3]),
      a: rgbaMatch[4] !== undefined ? Number(rgbaMatch[4]) : 1
    };
  }
  if (c.startsWith('#')) {
    let hex = c.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((ch) => ch + ch)
        .join('');
    }
    if (hex.length === 8) {
      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
        a: parseInt(hex.slice(6, 8), 16) / 255
      };
    }
    if (hex.length === 6) {
      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
        a: 1
      };
    }
  }
  return { r: 0, g: 0, b: 0, a: 1 };
}

function rgba({ r, g, b, a }: Rgba): string {
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function buildFullscreenTemplateBackgroundVars(baseColor?: string): Record<string, string> {
  const { r, g, b } = parseColorToRgba(baseColor);
  const start = rgba({ r, g, b, a: 0.8 });
  const end = rgba({ r, g, b, a: 0.3 });
  const pc = `linear-gradient(90deg, ${start} 0.6%, ${end} 97.91%)`;
  const mobile = `linear-gradient(180deg, ${start} 0.6%, ${end} 97.91%)`;

  return {
    [FULLSCREEN_GRADIENT_CSS_VARS.pc]: pc,
    [FULLSCREEN_GRADIENT_CSS_VARS.endPc]: pc,
    [FULLSCREEN_GRADIENT_CSS_VARS.mobile]: mobile,
    [FULLSCREEN_GRADIENT_CSS_VARS.mobileEnd]: mobile,
    '--cartx-fs-gradient-end-mobile': mobile
  };
}

export function getFullscreenTemplateBackgroundVarsFromStyleMap(
  styleMap: Record<string, Record<string, string>> | undefined,
  page: 'start' | 'middle' | 'end'
): Record<string, string> {
  const key = getFullscreenShowStyleMapKey(page);
  const bg = styleMap?.[key]?.background;
  return buildFullscreenTemplateBackgroundVars(bg);
}
